import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import { rootRoute } from './root-route';
import { sinkComponents } from './sink-config';

const sinkLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'sinkLayout',
  component: lazy(() =>
    import('@/router/components/SinkLayout').then((d) => ({ default: d.SinkLayout }))
  ),
});

const sinkIndexRoute = createRoute({
  getParentRoute: () => sinkLayoutRoute,
  path: '/sink',
  component: lazy(() => import('@/views/sink/Sink').then((d) => ({ default: d.Sink }))),
});

const sinkComponentRoutes = sinkComponents.map((config) =>
  createRoute({
    getParentRoute: () => sinkLayoutRoute,
    path: `/sink/${config.slug}`,
    component: config.component,
  })
);

export const sinkRouteTree = sinkLayoutRoute.addChildren([sinkIndexRoute, ...sinkComponentRoutes]);

export const showSinkRoute =
  import.meta.env.MODE === 'development' ||
  import.meta.env.VITE_DEPLOY_ENV === 'preview' ||
  import.meta.env.VITE_DEPLOY_ENV === 'development';
